export default function cleanString(input?: string | number): string {
  if (!input) return '';
  // Expressão regular para manter letras (incluindo acentuadas), números e espaços
  return String(input).replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ0-9 ()\-._:@/]/g, '');
}
